import request from '@@/utils/request'

// 首页交易信息列表
export function getTransactionList(params) {
    return request({
      url: '/zb/zbgg/zhu/list?ggAnnouncement='+params,
      method: 'get',
      headers: {
        isToken: false
      },
      data: params
    })
  }
  // 注册 /login/register
export function uregister(params) {
  return request({
    url: '/system/login/register',
    method: 'post',
    headers: {
      isToken: false
    },
    data: params
  })
}
// 供应商注册 /login/gysRegister
export function gysRegister(params) {
  return request({
    url: '/system/login/gysRegister',
    method: 'post',
    headers: {
      isToken: false
    },
    data: params
  })
}
// 专家注册 /login/zjRegister
export function zjRegister(params) {
  return request({
    url: '/system/login/zjRegister',
    method: 'post',
    headers: {
      isToken: false
    },
    data: params
  })
}
/** 新增招投标主体信息 */
export function addInfoApi(data) {
  return request({
    url: '/tb/infotb',
    method: 'post',
    data: data
  })
}

//查询轮播图图片
export function lbimages(data) {
  return request({
    url: '/yw/chart/list',
    method: 'get',
    headers: {
      isToken: false
    },
    data
  })
}
//查询交易页面数据
export function getZbggType(data) {
  return request({
    url: '/yw/zbgg/getZbggType',
    method: 'post',
    headers: {
      isToken: false
    },
    data
  })
}

//查询交易页面数据
export function getGgList(params) {
  return request({
    url: '/yw/zbgg/getGgList',
    method: 'get',
    params: params
  })
}
//查询交易页面数据
export function getGgListHome(params) {
  return request({
    url: '/yw/zbgg/getGgListHome',
    method: 'get',
    headers: {
      isToken: false
    },
    params: params
  })
}
export function getZmggListTwoMonth(params) {
  return request({
    url: '/yw/zbgg/getZmggListTwoMonth',
    method: 'get',
    headers: {
      isToken: false
    },
    params: params
  })
}
//查询帮助中心
export function helplist(data) {
  return request({
    url: '/yw/helpcenter/list?helpType='+data,
    headers: {
      isToken: false
    },
    method: 'get',
  })
}

//查询通知公告
export function noticeApi(params) {
  return request({
      url: '/system/notice/list',
      method: 'get',
      headers: {
        isToken: false
      },
      params: params
  })
}

//查询法律
export function lawApi(params) {
  return request({
    url: '/search/flfg/listAll',
    method: 'get',
    headers: {
      isToken: false
    },
    params: params
  })
}
//通知公告详情
export function noticeDetailsApi(id) {
  return request({
      url: '/system/notice/' + id,
      headers: {
        isToken: false
      },
      method: 'get'
  })
}
//法律法规详情
export function lawDetailsApi(id) {
  return request({
    url: '/search/flfg/' + id,
    headers: {
      isToken: false
    },
    method: 'get'
  })
}
//查询工具栏
export function toolslist(params) {
  return request({
    url: '/yw/tools/list',
    method: 'get',
    headers: {
      isToken: false
    },
    data: params
  })
}

//查询公告详情
export function getOneGg(data) {
  return request({
    url: `/yw/zbgg/getOneGg`,
    method: 'post',
    data
  })
}
//查询原公告
export function getOriginalGgApi(params) {
  return request({
    url: `/yw/zbgg/getOriginalGg`,
    method: 'get',
    headers: {
      isToken: false
    },
    params:params
  })
}
//帮助中心详情
export function getHelpcenterApi(id) {
  return request({
      url: '/yw/helpcenter/' + id,
      headers: {
        isToken: false
      },
      method: 'get'
  })
}
//首页统计
export function statisticsApi() {
  return request({
    url: '/zb/zbgg/zhu/statistics',
    headers: {
      isToken: false
    },
    method: 'get'
  })
}
//获取登陆人身份
export function getLoginStatus() {
  return request({
    url: '/zb/zbgg/zhu/getLoginStatus',
    method: 'get'
  })
}

export async function redirectToExtApp(redirUrl) {
  const resp = await request({
    url: '/extapp/redir',
    params: {
      r: encodeURI(redirUrl)
    }
  })
  if (resp.code == 200) {
    location.href = resp.data
  }
}
// 用户协议点击同意后，增加同意记录
export function noticeRecordApi() {
  return request({
    url: '/yw/sys/notice/record',
    method: 'post',
    headers: {
      isToken: true
    },
  })
}

//查询用户阅读协议状态
export function searchNoticeApi() {
  return request({
    url: '/yw/sys/notice/search',
    method: 'get',
    headers: {
      isToken: true
    },
  })
}

export function processCAApi(data) {
  return request({
    url: '/zb/newContract/processCA',
    method: 'post',
    data:data,
    headers: {
      isToken: false
    },
  })
}
